import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaGraduationCap, FaChevronRight } from 'react-icons/fa';
import { mbaAPI } from '../utils/api';
import '../styles/MbaProjects.scss';

const MbaGuidelines = () => {
  const navigate = useNavigate();
  const [universities, setUniversities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadUniversities = async () => {
      try {
        const res = await mbaAPI.getUniversities();
        setUniversities(Array.isArray(res.data?.data) ? res.data.data : []);
      } catch (err) {
        setError('Failed to load universities.');
      } finally {
        setLoading(false);
      }
    };
    loadUniversities();
  }, []);

  return (
    <div className="mba-projects-page" style={{ padding: '40px 16px' }}>
      <div className="back-link-container">
        <button className="btn-back-link" onClick={() => navigate('/mba-projects')}>
          <FaArrowLeft /> Back to MBA Projects
        </button>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#64748b', fontSize: '16px', fontWeight: '600' }}>
          Loading universities guidelines...
        </div>
      ) : error ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#b91c1c', fontSize: '16px', fontWeight: '600' }}>
          {error}
        </div>
      ) : (
        <section className="university-buttons-section" style={{ marginTop: '20px' }}>
          <div className="uni-section-header">
            <FaGraduationCap className="uni-section-icon" />
            <div>
              <h2>University Guidelines</h2>
              <p>Select your university to view formatting guidelines, report structures, certificate formats, and submission instructions.</p>
            </div>
          </div>
          <div className="university-buttons-grid">
            {universities.map((uni) => (
              <button
                key={uni.id}
                className="university-nav-btn"
                onClick={() => navigate(`/mba-projects/${uni.slug}`)}
                title={`View ${uni.name} Guidelines`}
              >
                <span className="uni-icon">🎓</span>
                <span className="uni-name-text">{uni.name}</span>
                <FaChevronRight className="uni-chevron" />
              </button>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default MbaGuidelines;
